export default __webpack_public_path__ + "static/react-native-uk-e172dd80ff99cc40159b68b61985b9bd.webp";